import { u, styled } from '../../../../shared/theming-sc'

const StyledRadioControlBox = styled.div`
    position: relative;
    text-align: left;
    border: 1px solid ${u.getColor('greyMuted')};
    border-radius: 6px;
    padding: 20px 0 6px 20px;

    .tr-FormRadioControl-label{          
        margin-bottom: 36px;

        &:last-child{
          margin-bottom: 0px;
        }
    }
`

const StyledDividerLine = styled.div.attrs({
  style: ({ top }) => ({ top })
})`
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px
  border-bottom: 1px solid ${u.getColor('greyMuted')};
`

export { 
  StyledRadioControlBox ,
  StyledDividerLine
};
